import SelectSearch from 'react-select-search'

import { FilterStateType } from 'pages/samples/category/[categorySlug]'

/* styling */
import styles from './_.module.css'

interface Props {
  filters: FilterStateType
  contentTypes: { id: string; name: string; slug: string }[]
  industries: { id: string; name: string; slug: string }[]
  creatorLevels: { id: string; name: string; slug: string }[]
  handleFilterChange: (key: string, value: string) => void
}

function SamplesFilterDropdown({
  filters,
  industries,
  creatorLevels,
  contentTypes,
  handleFilterChange
}: Props) {
  return (
    <div className="flex flex-col lg:flex-row lg:space-x-3 space-y-3 lg:space-y-0">
      {/* content type filter will be on sidebar for xl screens */}
      <div className="xl:hidden">
        <SelectSearch
          className={(key: string) => styles[key]}
          onChange={value =>
            handleFilterChange('contentType', value as unknown as string)
          }
          value={filters['contentType']}
          options={contentTypes.map(item => ({
            name: item.name,
            value: item.slug
          }))}
          placeholder="All Content Types"
          search={true}
          debounce={500}
        />
      </div>

      <SelectSearch
        className={(key: string) => styles[key]}
        onChange={value =>
          handleFilterChange('industry', value as unknown as string)
        }
        value={filters['industry']}
        options={industries.map(item => ({
          name: item.name,
          value: item.slug
        }))}
        placeholder="Industry"
        search={true}
        debounce={500}
      />

      <SelectSearch
        className={(key: string) => styles[key]}
        onChange={value =>
          handleFilterChange('creatorLevel', value as unknown as string)
        }
        value={filters['creatorLevel']}
        options={creatorLevels.map(item => ({
          name: item.name,
          value: item.slug
        }))}
        placeholder="Creator Level"
        search={true}
        debounce={500}
      />
    </div>
  )
}

export default SamplesFilterDropdown
